var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomerForm',{attrs:{"customer":_vm.customer,"buttonLoading":_vm.buttonLoading},on:{"saveCustomer":_vm.saveCustomer}})}
var staticRenderFns = []

export { render, staticRenderFns }